import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { registerServiceWorker } from './lib/push'
import './styles/app.css'

const root = document.getElementById('root')
if (!root) throw new Error('No #root element in index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/**
 * Register before anyone signs in. A browser will not offer to install a site,
 * and iOS will not treat it as a home-screen app, until a service worker and a
 * manifest are both live - and the login screen is the first thing a new coach
 * sees. Registration is idempotent, so calling it again later is harmless.
 */
window.addEventListener('load', () => {
  void registerServiceWorker()
})
